import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Header from '../layout/header/Header'
import Login from '../auth/login/Login'
import {setAsAuthenticated, getMeDetails} from '../../redux/actions/authActions'
import './Content.css'
import Home from '../home/Home'
import Footer from '../layout/footer/Footer'
import { getHomeData } from '../../redux/actions/dataActions'
import UtiDialog from '../layout/dialog/UtiDialog'
import { Routes, useLocation, useNavigate, Route } from 'react-router-dom'


function Content() {
  
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  
  useEffect(() => {
    if (!isAuthenticated && ((sessionStorage.getItem('AuthToken') && sessionStorage.getItem('AuthToken') != 'undefined') || location.search)) {
      const searchUrl = new URLSearchParams(location.search)
      if (searchUrl.get('t')) {
        dispatch(setAsAuthenticated(searchUrl.get('t')))
        dispatch(getHomeData())
        navigate(location.pathname, { replace: true })
      } else  if (sessionStorage.getItem('AuthToken')) {
        dispatch(setAsAuthenticated(sessionStorage.getItem('AuthToken')))
        dispatch(getHomeData())
      } 
     
    }  
  }, [])

  return (
    <div className='content_page' dir="rtl">
      <div className='content'>
        <Header /> 
        {!isAuthenticated ? <Login /> :
        <Routes>
          <Route path="/" element={ <Home />}></Route>
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
        </Routes>
         }
        <UtiDialog/>
      </div>
      <div className='footer'>
          <Footer isLog={!isAuthenticated } />
      </div>
    </div>
  )
}

export default Content
